<template>
    <div class="animated fadeIn">
        <div v-if="!loading">
            <div>
                <b-table
                    style="border-radius: 12px"
                    :dark="false"
                    :hover="true"
                    :striped="false"
                    :bordered="true"
                    :small="false"
                    :fixed="false"
                    responsive
                    :items="ratingReviewList"
                    :fields="commissionRuleColumns"
                    :current-page="currentPage"
                    :per-page="perPage"
                    thead-class="header"
                    :filter="filter"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    show-empty
                >
                    <template slot="cell(name)" slot-scope="data">
                        {{ data.item.givenBy.name.first }}
                        {{ data.item.givenBy.name.last }}
                    </template>
                    <template slot="cell(stars)" slot-scope="data">
                        <RatingBar :rating="data.item.stars" />
                    </template>
                    <template slot="cell(status)" slot-scope="data">
                        <div
                            :class="
                                data.item.reviewStatus === 'PUBLISH'
                                    ? 'btn-publish'
                                    : data.item.reviewStatus === 'REJECT'
                                      ? 'btn-reject'
                                      : 'btn-pending'
                            "
                            :rating="data.item.stars"
                        >
                            {{
                                data.item.reviewStatus === "PUBLISH"
                                    ? "PUBLISHED"
                                    : data.item.reviewStatus === "REJECT"
                                      ? "REJECTED"
                                      : data.item.reviewStatus
                            }}
                        </div>
                    </template>

                    <template slot-scope="data" slot="cell(action)">
                        <div class="inline_btnTable">
                            <b-button
                                size="sm"
                                class="butto-circle mr-1"
                                variant="primary"
                                @click="showDetail(data.item)"
                            >
                                <i class="fa fa-eye"></i>
                            </b-button>
                            <b-button
                                @click="openChat(data.item)"
                                size="sm"
                                class="butto-circle mr-1"
                                variant="primary"
                            >
                                <i class="fas fa-comment"></i>
                            </b-button>
                        </div>
                    </template>
                    <template slot="cell(empty)">
                        <div v-if="isloading" class="text-center">
                            <span><b>Loading...</b></span>
                        </div>
                        <div v-else class="text-center">No data available.</div>
                    </template>
                </b-table>
            </div>
            <b-modal
                v-model="ratingOverviewModal"
                title="Customer Rating Details"
                header-class="header-nipige-class"
                :header-bg-variant="'primary'"
                :header-text-variant="'light'"
                size="sm"
                centered
                hide-footer
                no-close-on-esc
                no-close-on-backdrop
                modal-class="modal-wide"
            >
                <div class="mb-2">
                    <div class="border rounded-md">
                        <b-row>
                            <b-col cols="6" class="text-left">
                                <strong>Review Id : </strong>
                                <span class="ml-2">{{ ratingDetail._id }}</span>
                            </b-col>
                            <b-col cols="6" class="text-left">
                                <strong>Customer Name:</strong>
                                <span class="ml-2">{{
                                    ratingDetail.givenBy &&
                                    ratingDetail.givenBy.name.first +
                                        " " +
                                        ratingDetail.givenBy &&
                                    ratingDetail.givenBy.name.last
                                }}</span>
                            </b-col>
                        </b-row>
                        <!-- Row 2: Item Name & Rating -->
                        <b-row class="bg-light py-1">
                            <b-col cols="6" class="text-left">
                                <strong>Item Name:</strong>
                                <span class="ml-2">{{
                                    ratingDetail.itemName
                                }}</span>
                            </b-col>
                            <b-col cols="6" class="text-left">
                                <strong class="mr-2">Rating:</strong>
                                <RatingBar :rating="ratingDetail.stars" />
                            </b-col>
                        </b-row>
                        <!-- Row 3: Review Text -->
                        <b-row>
                            <b-col md="12" class="text-left">
                                <strong>Review Text :</strong>
                                <span class="ml-2">{{
                                    ratingDetail.feedbackComment
                                }}</span>
                            </b-col>
                        </b-row>
                    </div>
                    <h4 class="text-left">Image</h4>
                    <div class="border rounded-md mt-2">
                        <ImageGallery :media="mediaList" />
                    </div>
                    <div
                        v-if="ratingDetail.reviewStatus === 'PENDING'"
                        class="text-center mt-3"
                    >
                        <b-button
                            variant="success"
                            size="md"
                            class="mr-3"
                            @click="handleApprovelStatus('PUBLISH')"
                            >Approve</b-button
                        >
                        <b-button
                            variant="danger"
                            size="md"
                            class="px-3"
                            @click="handleApprovelStatus('REJECT')"
                            >Reject</b-button
                        >
                    </div>
                    <div v-else class="text-center mt-3">
                        <b-button
                            :variant="
                                ratingDetail.reviewStatus === 'REJECT'
                                    ? 'danger'
                                    : 'success'
                            "
                            size="md"
                            disabled
                            class="px-3"
                            >{{
                                ratingDetail.reviewStatus === "REJECT"
                                    ? "REJECTED"
                                    : "PUBLISHED"
                            }}</b-button
                        >
                    </div>
                </div>
            </b-modal>

            <b-modal
                v-model="chatOptionModal"
                title="Chat"
                header-class="header-nipige-class"
                :header-bg-variant="'primary'"
                :header-text-variant="'light'"
                size="md"
                centered
                hide-footer
                no-close-on-esc
                no-close-on-backdrop
            >
                <div class="text-center p-3">
                    <b-button
                        variant="success"
                        size="md"
                        class="mr-3"
                        @click="chatWithCustomer"
                    >
                        <i class="fas fa-comment"></i> Chat with
                        customer</b-button
                    >
                    <b-button
                        variant="success"
                        size="md"
                        class="px-3"
                        @click="replyToCustomer"
                    >
                        <i class="fas fa-headset"></i> Reply to
                        customer</b-button
                    >
                </div>
            </b-modal>
            <b-modal
                v-model="chatWithCustomerModal"
                title="Chat with customer"
                header-class="header-nipige-class"
                :header-bg-variant="'primary'"
                :header-text-variant="'light'"
                size="lg"
                centered
                hide-footer
                no-close-on-esc
                no-close-on-backdrop
            >
                <div v-if="chatWithCustomerModal" class="text-center">
                    <ChatBox :reviewDetail="ratingDetail"></ChatBox>
                </div>
            </b-modal>
            <b-modal
                v-model="replyToCustomerModal"
                title="Reply to customer"
                header-class="header-nipige-class"
                :header-bg-variant="'primary'"
                :header-text-variant="'light'"
                size="lg"
                centered
                hide-footer
                no-close-on-esc
                no-close-on-backdrop
            >
                <div v-if="replyToCustomerModal" class="text-center">
                    <ReplyChatBox :reviewDetail="ratingDetail"></ReplyChatBox>
                </div>
            </b-modal>
            <div class="float-right">
                <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="ratingReviewList ? ratingReviewList.length : 0"
                    aria-controls="my-table"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                ></b-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import RatingBar from "@/components/Common/RatingBar.vue";
import ImageGallery from "@/components/Common/ImageGallery.vue";
import ChatBox from "@/views/rating/ChatBox.vue";
import ReplyChatBox from "@/views/rating/ReplyChatBox.vue";

export default {
    name: "CustomerRating",
    data() {
        return {
            filter: "",
            loading: false,
            isloading: false,
            ratingOverviewModal: false,
            chatOptionModal: false,
            chatWithCustomerModal: false,
            replyToCustomerModal: false,
            ratingDetail: {},
            currentPage: 1,
            perPage: 10,
            sortBy: "createdAt",
            sortDesc: true,
            commissionRuleColumns: [
                {
                    key: "name",
                    label: "Customer Name",
                },
                {
                    key: "itemName",
                    label: "Item Name",
                },
                {
                    key: "stars",
                    label: "Rating",
                },
                {
                    key: "feedbackComment",
                    label: "Review Text",
                    formatter: (value) => {
                        if (!value) return "";
                        const text =
                            value.length > 30
                                ? value.slice(0, 30) + "..."
                                : value;
                        return text.charAt(0).toUpperCase() + text.slice(1);
                    },
                },
                {
                    key: "status",
                    label: "Status",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    components: {
        ebButton,
        ComponentHeader,
        RatingBar,
        ImageGallery,
        ChatBox,
        ReplyChatBox,
    },
    computed: {
        ...mapGetters({
            getFetchCommissionRule: "commission/GetFetchCommissionRule",
        }),
        ...mapState({
            reviewList: (state) => state.partner.reviewList,
        }),
        ratingReviewList() {
            return this.reviewList.flatMap((ratingData) => {
                const { ratings, ...rest } = ratingData;
                return (ratings || []).map((rating) => ({
                    ...rating,
                    ...rest,
                    rateingId: rating._id,
                }));
            });
        },
        mediaList() {
            if (!this.ratingDetail || !Array.isArray(this.ratingDetail.media)) {
                return [];
            }
            return this.ratingDetail.media;
        },
    },
    methods: {
        showDetail(data) {
            this.ratingDetail = data;
            this.ratingOverviewModal = true;
        },
        viewRule(data) {
            this.$router.push({
                name: "CommissionSetupView",
                params: {
                    id: data._id,
                },
            });
        },
        openChat(data) {
            this.ratingDetail = data;
            this.chatOptionModal = true;
        },
        chatWithCustomer() {
            this.chatWithCustomerModal = true;
        },
        replyToCustomer() {
            this.replyToCustomerModal = true;
        },
        async reloadData() {
            this.isloading = true;
            await this.$store.dispatch("commission/fetchCommissionRuleAction");
            this.isloading = false;
        },
        async handleApprovelStatus(approval) {
            this.isloading = true;
            try {
                let payload = {
                    id: this.ratingDetail.rateingId,
                    load: {
                        reviewStatus: approval,
                        subjectId: this.ratingDetail.subjectId,
                    },
                };
                await this.$store.dispatch(
                    "partner/updateApprovalAction",
                    payload,
                );
                approval === "PUBLISH"
                    ? this.$swal({
                          title: "Approvel",
                          text: "Published!",
                          type: "info",
                      })
                    : this.$swal({
                          title: "Approvel",
                          text: "Rejected!",
                          type: "info",
                      });

                this.ratingOverviewModal = false;
                this.getReviewList();
            } catch (error) {
                this.$toasted.error(error);
            } finally {
                this.isloading = false;
            }
        },
        async getReviewList() {
            this.loading = true;
            await this.$store.dispatch(
                "partner/getReviewListAction",
                this.$route.params.id,
            );
            this.loading = false;
        },
    },

    mounted() {
        this.getReviewList();
    },
};
</script>

<style>
.modal-wide .modal-dialog {
    max-width: 700px !important;
    width: 50vw;
}
</style>

<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
<style scoped>
.btn-publish,
.btn-reject,
.btn-pending {
    padding: 0.35rem 0.6rem;
    font-size: 0.75rem;
    border-radius: 6px;
    background: transparent;
    cursor: default;
    user-select: none;
}

.btn-publish {
    color: #4caf50;
    border: 2px solid #4caf50;
}

.btn-pending {
    color: #ffa726;
    border: 2px solid #ffa726;
}

.btn-reject {
    color: #ff3b3b;
    border: 2px solid #ff3b3b;
}
.rounded-md {
    border-radius: 6px;
    padding: 14px;
}
</style>
